import React from 'react';
import { View, Text, Dimensions } from 'react-native';
import styles from '../screens/EventsScreen.styles';
import { formatEventFooterPercent } from '../utils/eventDisplay';
import { isXl } from '../utils/responsiveStyles';

interface EventItemProps {
  isin: string;
  productName: string;
  eventDescription: string;
  eventDate: string;
  amount: number;
  notional: number;
  couponPercent: number;
  /** Matches product detail → Coupons → first row Amount (%) */
  firstCouponAmountPct: number;
  currency: string;
  formatDate: (dateString: string) => string;
  formatAmount: (amount: number, currency: string) => string;
  onPress?: () => void;
}

export const EventItem: React.FC<EventItemProps> = ({
  isin,
  productName,
  eventDescription,
  eventDate,
  amount,
  notional,
  couponPercent,
  firstCouponAmountPct,
  currency,
  formatDate,
  formatAmount,
  onPress,
}) => {
  const { width } = Dimensions.get('window');
  const isTablet = isXl(width) && width < 1024;
  const { TouchableOpacity } = require('react-native');
  
  const CardWrapper = onPress ? TouchableOpacity : View;
  const cardProps = onPress ? { onPress, activeOpacity: 0.7 } : {};

  const showNominalAmount = eventDescription === 'Product Maturity';
  const hasMaturityAmount = showNominalAmount && amount > 0;
  const footerMain = showNominalAmount
    ? hasMaturityAmount
      ? formatAmount(amount, currency)
      : '—'
    : formatEventFooterPercent(firstCouponAmountPct, amount, notional, couponPercent);

  return (
    <CardWrapper {...cardProps} style={[styles.eventCard, isTablet && styles.eventCardTablet]}>
      <View style={styles.eventCardHeader}>
        <Text style={styles.eventTypeLabel}>{eventDescription}</Text>
      </View>
      <View style={styles.eventCardContent}>
        <View style={styles.eventLeftSection}>
          <Text style={styles.eventIsin}>{isin || 'N/A'}</Text>
          <Text style={styles.eventProductName} numberOfLines={2}>
            {productName}
          </Text>
        </View>
      </View>
      <View style={styles.eventCardFooter}>
        <Text style={styles.eventDate}>{formatDate(eventDate)}</Text>
        <View style={styles.eventAmountContainer}>
          <Text style={styles.eventAmount}>{footerMain}</Text>
          {hasMaturityAmount ? <Text style={styles.eventCurrency}>{currency}</Text> : null}
        </View>
      </View>
    </CardWrapper>
  );
};


